const initialState = {
    noData: false,
    searchList: [],
    updatedList: [],
    fetching: false,
    fetched: false,
    page: 1,
    pages: 0,
    error: null,

    createdList: [],
    updating: false,
    updated: false,
    errorUpdated: null
}

export function jobsReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_JOBS_TOKEN":
        case "FETCH_JOBS_LIST_UPDATED_TOKEN":
        case "FETCH_JOBS_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "FETCH_JOBS": {
            return { ...state, fetching: true, fetched: false, page: 1, error: null }
        }

        case "FETCH_JOBS_LIST_UPDATED": {
            return { ...state, fetching: true, fetched: false, page: action.payload.data, error: null }
        }
        case "FETCH_JOBS_LIST": {
            return { ...state, fetching: true, fetched: false, page: 1, error: null }
        }

        case "FETCH_JOBS_REJECTED":
        case "FETCH_JOBS_LIST_UPDATED_REJECTED":
        case "FETCH_JOBS_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "FETCH_JOBS_FULFILLED": {
            action.payload.data.jobStartDateTimeDisplay = ""
            action.payload.data.jobEndDateTimeDisplay = ""

            if (action.payload.data.jobStartDateTime != null) {
                var date = new Date(action.payload.data.jobStartDateTime);
                var hours = Math.abs(date.getHours() - 5);
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';

                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                action.payload.data.jobStartDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            }

            if (action.payload.data.jobEndDateTime != null) {
                var date = new Date(action.payload.data.jobEndDateTime);
                var hours = Math.abs(date.getHours() - 5);
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';

                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                action.payload.data.jobEndDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            }

            var job = []

            job.push(action.payload.data)

            return {
                ...state,
                fetching: false,
                fetched: true,
                pages: 1,
                updatedList: job
            }
        }

        case "FETCH_JOBS_LIST_UPDATED_FULFILLED": {
            let jobs

            action.payload.data.results.map((job) => {
                job.jobStartDateTimeDisplay = ""
                job.jobEndDateTimeDisplay = ""

                if (job.jobStartDateTime != null) {
                    var date = new Date(job.jobStartDateTime);
                    var hours = Math.abs(date.getHours() - 5);
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';

                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    job.jobStartDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
                }

                if (job.jobEndDateTime != null) {
                    var date = new Date(job.jobEndDateTime);
                    var hours = Math.abs(date.getHours() - 5);
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';

                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    job.jobEndDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
                }
            });

            if (state.page === 1)
                jobs = action.payload.data.results
            else {
                jobs = Object.assign([], state.updatedList)
                action.payload.data.results.forEach((job) => jobs.push(job))
            }

            return {
                ...state,
                fetching: false,
                fetched: true,
                pages: action.payload.data.totalPages,
                results: action.payload.data.totalResults,
                updatedList: jobs
            }
        }

        case "FETCH_JOBS_LIST_FULFILLED": {
            let jobs

            action.payload.data.results.map((job) => {
                job.jobStartDateTimeDisplay = ""
                job.jobEndDateTimeDisplay = ""

                if (job.jobStartDateTime != null) {
                    var date = new Date(job.jobStartDateTime);
                    var hours = Math.abs(date.getHours() - 5);
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';

                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    job.jobStartDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
                }

                if (job.jobEndDateTime != null) {
                    var date = new Date(job.jobEndDateTime);
                    var hours = Math.abs(date.getHours() - 5);
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';

                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    job.jobEndDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
                }
            });

            jobs = action.payload.data.results

            return {
                ...state,
                fetching: false,
                fetched: true,
                noData: action.payload.data.results.length == 0, 
                pages: action.payload.data.totalPages,
                results: action.payload.data.totalResults,
                searchList: jobs,
                updatedList: jobs,
                createdList: []
            }
        }

        case "FETCH_JOBS_ERROR": {
            return { ...state, error: null }
        }

        case "CREATE_JOB": {
            return { ...state, updating: true, updated: false, errorUpdated: null }
        }

        case "CREATE_JOB_REJECTED": {
            return { ...state, updating: false, errorUpdated: action.payload }
        }

        case "CREATE_JOB_FULFILLED": {
            action.payload.data.jobStartDateTimeDisplay = ""
            action.payload.data.jobEndDateTimeDisplay = ""

            if (action.payload.data.jobStartDateTime != null) {
                var date = new Date(action.payload.data.jobStartDateTime);
                var hours = Math.abs(date.getHours() - 5);
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';

                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                action.payload.data.jobStartDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            }

            if (action.payload.data.jobEndDateTime != null) {
                var date = new Date(action.payload.data.jobEndDateTime);
                var hours = Math.abs(date.getHours() - 5);
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';

                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                action.payload.data.jobEndDateTimeDisplay = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            }

            var job = state.createdList

            job.push(action.payload.data)

            return {
                ...state,
                updating: false,
                updated: true,
                createdList: job
            }
        }

        case "JOB_ERROR": {
            return { ...state, error: null, errorUpdated: null }
        }
        case "NODATA_ERROR_CLEAR": {
            return { ...state, noData: false }
        }

        default:
            return state
    }
}
